module.exports = __webpack_public_path__ + "static/media/add-delete-member.2b5afb7f.png";